export default "__VITE_ASSET__D9jdyzN2__"